<template>
  <div class="example-image">
    <div v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10">
      <div class="row text-center">
        <div v-for="i in sample" :key="i" class="col-12 col-md-6 col-lg-4 p-3">
          <SampleImage :seed="i" />
        </div>

        <PuSkeleton v-if="busy" class="busy col-12"></PuSkeleton>
      </div>
    </div>
  </div>
</template>

<script>
import SampleImage from "@/components/SampleImage.vue";

export default {
  name: "sampleImages",
  components: { SampleImage },
  data() {
    return { sample: 6, busy: false };
  },
  methods: {
    loadMore: function() {
      this.busy = true;

      setTimeout(() => {
        for (let i = 0; i < 12; i++) {
          this.sample++;
        }
        this.busy = false;
      }, 1000);
    }
  }
};
</script>

<style lang="scss" scoped>
.example-image {
  height: calc(100vh - 120px);
  overflow: scroll;
  overflow-x: hidden;
}
.example-image::-webkit-scrollbar {
  display: none;
}
.busy {
  height: 20vh;
}
</style>